import React from "react";
import { Text, TextLink } from "@origin-digital/ods-core";

import { routes } from "../../helpers/router.helper";
import { StyledLink } from "../../helpers/styles";

interface IHighlightedArticle {
  label: string;
  link: string;
}

interface IHighlightedArticles {
  categoryUri: string;
  items: IHighlightedArticle[];
  categoryTitle: string;
}

// Using ul/li instead of List/ListItem as I don't need the extra styling
// CSS standardised in QuickLink.styles

export const HighlightedArticles = ({
  categoryUri,
  items,
  categoryTitle,
}: IHighlightedArticles) => {
  return (
    <ul aria-label={`Highlighted articles from ${categoryTitle}`}>
      {items.map(({ label, link }: IHighlightedArticle) => {
        const isExternalLink = link.startsWith("/"); // NOTE: Temp update to handle links to be shuffled into place

        return (
          <li key={link}>
            <Text>
              {isExternalLink ? (
                <TextLink href={link}>{label}</TextLink>
              ) : (
                <StyledLink to={routes.subcategory(categoryUri, link)}>
                  {label}
                </StyledLink>
              )}
            </Text>
          </li>
        );
      })}
    </ul>
  );
};
